import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "Bench",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "Bench",
    description: "Bench",
    image: require("./Bench.svg"),
    svgIcon: require("./Bench.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 100,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 100,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g transform={`translate(-19, 55) scale(1, -1)`}>
          <defs>
            <style>{`.cls-1{fill:#fff;}`}</style>
          </defs>
          <g id={`${element.type}-${element.id}`} data-name="corner shower">
            <path
              d="M93.53,60.19v2.56c1.18.41,1.18.41,1.18,1.68,0,2.24,0,4.48,0,6.71,0,.8-.14,1.35-1.13,1.23a5.28,5.28,0,0,0-.08.62c0,.63-.28.87-.91.86-1.19,0-2.38,0-3.57,0-1.46,0-1.46,0-1.69-1.43H13c-.26,1.43-.26,1.43-1.7,1.43H8.42c-1.48,0-1.48,0-1.68-1.36-1.28-.29-1.28-.29-1.28-1.63V64.4c0-1.35,0-1.35,1.35-1.59,0-.74,0-1.52,0-2.29a.66.66,0,0,0-.47-.43c-.72,0-.86-.41-.86-1,0-2.32,0-4.65,0-7,0-1.31,0-1.31,1.3-1.57V47.9c-1.3-.26-1.3-.26-1.3-1.57V39.88c0-1.35,0-1.35,1.36-1.67,0-1.07,0-2.17,0-3.26,0-.75.26-1.05,1-1,1.34,0,2.67,0,4,0,.82,0,1.07.33,1.05,1.09,0,1.07,0,2.14,0,3.28h8.29V33.08H6.76c-1.28,0-1.3,0-1.3-1.33v-2c0-1.19.06-1.24,1.22-1.25H21.24V27c0-.56.24-.85.85-.83,1,0,1.92,0,2.87,0,.79,0,1.05.33,1,1,0,.38,0,.75,0,1.2H74.14c0-.43,0-.88,0-1.33,0-.69.31-.92,1-.9.93,0,1.86,0,2.79,0,.73,0,1,.29,1,1,0,.4,0,.8,0,1.32H93.45c1.22,0,1.26.05,1.26,1.3v2c0,1.26,0,1.29-1.26,1.29H78.89v5.21h8.54c0-1.12,0-2.21,0-3.31,0-.78.28-1.09,1.08-1.06,1.3,0,2.61,0,3.92,0,.86,0,1.13.32,1.09,1.13,0,1,0,2.09,0,3.12,1.2.43,1.2.43,1.2,1.78,0,2.21,0,4.42,0,6.62,0,.78-.09,1.39-1.14,1.21v2.79c1,0,1.17.58,1.15,1.45,0,2.24,0,4.47,0,6.71C94.71,59.92,94.71,59.92,93.53,60.19ZM12.89,46.81H87.37V39.23H14.24a2.19,2.19,0,0,0-.77,0c-.23.1-.56.35-.56.54C12.87,42.11,12.89,44.43,12.89,46.81Zm74.49,4.71H31.45c-5.9,0-11.79,0-17.69,0-.67,0-.91.17-.89.88,0,1.88,0,3.77,0,5.66,0,1.15,0,1.15,1.12,1.15H87.38ZM12.93,71.43H87.35V63.86H12.93ZM26,38.29H74.1V33.15H26Zm68-8.86H6.21v2.72H94Zm-1.21,5.44H88.17v38h4.61ZM12.15,72.93V34.86H7.57V72.93Zm62-12.8H26v2.74H74.11Zm0-12.28H26a15.77,15.77,0,0,1,0,1.69c-.1.85.17,1.12,1.08,1.12q23.06,0,46.09,0c.31,0,.62,0,1,0Zm4.79,15h8.47v-2.7H78.89Zm-66,.07c2.72,0,5.29,0,7.87,0,.88,0,.47-.88.44-1.31s.51-1.27-.45-1.51h-.09c-2.4,0-4.81,0-7.21,0a.74.74,0,0,0-.54.46C12.85,61.29,12.89,62.05,12.89,62.92Zm66-12.35h8.45V47.84H78.91ZM17,50.64h2.25c2.07,0,2.05,0,2-2.07,0-.61-.2-.8-.8-.79-1.85,0-3.7,0-5.56,0-2.11,0-2.09,0-2,2.16,0,.52.18.71.71.7C14.71,50.62,15.84,50.64,17,50.64Zm4.94-12.36h3.34V33.09c-1,0-1.94,0-2.89,0-.16,0-.43.24-.43.38C21.9,35.07,21.91,36.66,21.91,38.28Zm53-5.15v5.15H78.1V33.13ZM22,62.86H25.3c0-.68,0-1.29,0-1.89s-.2-.92-.92-.92C21.68,60.07,21.68,60,22,62.86Zm52.89,0h3.26V60.13H74.86ZM25.3,50.6c0-.82,0-1.54,0-2.25a.78.78,0,0,0-.54-.53,15.5,15.5,0,0,0-2.26,0c-.19,0-.53.23-.54.37-.05.79,0,1.59,0,2.42Zm52.81,0V47.86H74.89V50.6ZM6.15,43c0,1.1,0,2.2,0,3.3,0,.2.19.4.29.6.12-.19.35-.37.35-.55q0-3.27,0-6.52c0-.19-.23-.37-.35-.56-.1.2-.28.4-.29.6C6.13,40.9,6.15,42,6.15,43Zm0,16.08.32.18c.11-.21.31-.41.33-.63a14.38,14.38,0,0,0,0-1.47c0-1.68,0-3.36,0-5,0-.19-.22-.38-.34-.57-.1.17-.3.33-.3.5C6.14,54.38,6.15,56.72,6.15,59.07Zm.26,4.69-.2.14v7.53l.2.11c.13-.17.39-.35.39-.52,0-2.24,0-4.47,0-6.71C6.8,64.13,6.54,63.94,6.41,63.76Zm18.84-36.6H21.86c.22.5-.38,1.23.51,1.31s1.89,0,2.88,0Zm52.87,0H74.89v1.29h3.23ZM93.94,51.57l-.22-.07a1.64,1.64,0,0,0-.2.53c0,2.21,0,4.41,0,6.62,0,.18.16.37.25.55l.17-.07Zm0-4.63V39.08C93.35,39.92,93.4,46.44,93.9,46.94ZM94,63.74c-.47.44-.67,4.92-.44,7.28a1.75,1.75,0,0,0,.23.48l.21-.07Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M12.89,46.81c0-2.38,0-4.7,0-7,0-.19.33-.44.56-.54a2.19,2.19,0,0,1,.77,0H87.37v7.58Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M87.38,51.52v7.67H14c-1.12,0-1.12,0-1.12-1.15,0-1.89,0-3.78,0-5.66,0-.71.22-.88.89-.88,5.9,0,11.79,0,17.69,0H87.38Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M12.93,71.43V63.86H87.35v7.57Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M26,38.29V33.15H74.1v5.14Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M94,29.43v2.72H6.21V29.43Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M92.78,34.87v38H88.17v-38Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M12.15,72.93H7.57V34.86h4.58Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M74.11,60.13v2.74H26V60.13Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M74.1,47.85V50.6c-.35,0-.66,0-1,0q-23,0-46.09,0c-.91,0-1.18-.27-1.08-1.12a15.77,15.77,0,0,0,0-1.69Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M78.89,62.85v-2.7h8.47v2.7Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M12.89,62.92c0-.87,0-1.63,0-2.37a.74.74,0,0,1,.54-.46c2.4,0,4.81,0,7.21,0h.09c1,.24.41,1,.45,1.51s.44,1.28-.44,1.31C18.18,63,15.61,62.92,12.89,62.92Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M78.91,50.57V47.84h8.45v2.73Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M17,50.64c-1.13,0-2.26,0-3.39,0-.53,0-.69-.18-.71-.7-.07-2.16-.09-2.16,2-2.16,1.86,0,3.71,0,5.56,0,.6,0,.79.18.8.79,0,2.07,0,2.07-2,2.07Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M21.91,38.28c0-1.62,0-3.21,0-4.79,0-.14.27-.38.43-.38.95,0,1.9,0,2.89,0v5.19Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M74.86,33.13H78.1v5.15H74.86Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M22,62.86c-.29-2.82-.29-2.79,2.42-2.81.72,0,1,.2.92.92s0,1.21,0,1.89Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M74.86,62.87V60.13h3.26v2.74Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M25.3,50.6H21.91c0-.83,0-1.63,0-2.42,0-.14.35-.36.54-.37a15.5,15.5,0,0,1,2.26,0,.78.78,0,0,1,.54.53C25.34,49.06,25.3,49.78,25.3,50.6Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M78.11,50.6H74.89V47.86h3.22Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M6.15,43c0-1,0-2.09,0-3.13,0-.2.19-.4.29-.6.12.19.35.37.35.56q0,3.26,0,6.52c0,.18-.23.36-.35.55-.1-.2-.28-.4-.29-.6C6.13,45.19,6.15,44.09,6.15,43Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M6.15,59.07c0-2.35,0-4.69,0-7,0-.17.2-.33.3-.5.12.19.34.38.34.57,0,1.68,0,3.36,0,5a14.38,14.38,0,0,1,0,1.47c0,.22-.22.42-.33.63Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M6.41,63.76c.13.18.39.37.39.55,0,2.24,0,4.47,0,6.71,0,.17-.26.35-.39.52l-.2-.11V63.9Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M25.25,27.16v1.33c-1,0-1.94.07-2.88,0s-.29-.81-.51-1.31Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M78.12,27.13v1.29H74.89V27.13Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M93.94,51.57v7.56l-.17.07c-.09-.18-.25-.37-.25-.55,0-2.21,0-4.41,0-6.62a1.64,1.64,0,0,1,.2-.53Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M93.9,46.94c-.5-.5-.55-7,0-7.86Z"
              transform="translate(-5.46 -26.18)"
            />
            <path
              class="cls-1"
              d="M94,63.74v7.69l-.21.07a1.75,1.75,0,0,1-.23-.48C93.29,68.66,93.49,64.18,94,63.74Z"
              transform="translate(-5.46 -26.18)"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
